import { render } from "./CommunityBanner.vue?vue&type=template&id=62a2e8fa&scoped=true"
import script from "./CommunityBanner.vue?vue&type=script&lang=js"
export * from "./CommunityBanner.vue?vue&type=script&lang=js"

import "./CommunityBanner.vue?vue&type=style&index=0&id=62a2e8fa&scoped=true&lang=css"

import exportComponent from "E:\\changjuCode\\official-web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62a2e8fa"]])

export default __exports__